ui-cms-link-list {
  display: block;

  --columns: 1;

  h4 {
    margin-bottom: $sd-spacing-3;
  }

  .wrapper {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: $sd-spacing-4;
  }

  .link-list {
    margin: 0;
    @include list-unstyled;

    display: flex;
    flex-direction: column;
    gap: $sd-spacing-4;

    &--horizontal {
      flex-flow: wrap;
      flex-direction: row;
      gap: $sd-spacing-8;
    }
  }
}
